// src/components/CourseManagement.js
import React, { useState } from "react";
import { Paper, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import CourseUpload from "./CourseUpload";
import CourseEdit from "./CourseEdit";

const CourseManagement = () => {
  const [mode, setMode] = useState("");

  const handleModeChange = (e) => {
    setMode(e.target.value);
  };

  return (
    <Paper elevation={2} sx={{ p: 2, my: 2 }}>
      <Typography variant="h5" gutterBottom>
        Course Management - Untested Feature
      </Typography>
      <FormControl component="fieldset" sx={{ mb: 2 }}>
        <RadioGroup row value={mode} onChange={handleModeChange}>
          <FormControlLabel value="add" control={<Radio />} label="Add New Course" />
          <FormControlLabel value="edit" control={<Radio />} label="Modify Existing Course" />
        </RadioGroup>
      </FormControl>
      {mode === "add" && <CourseUpload />}
      {mode === "edit" && <CourseEdit />}
    </Paper>
  );
};

export default CourseManagement;